// Employee spending excludes company-paid bookings. Carry-forward applied to
// a trip is already included in advance_amount; only unapplied funds are added.
const tripRemainingFunds = (trip) => Math.round((
  Number(trip.advance_amount || 0)
  - Number(trip.employee_expenses_total ?? trip.total_expenses ?? 0)
  - Number(trip.returned_amount || 0)
) * 100) / 100;

const availableToSpend = (trips, carryForward = 0) => Math.round((
  trips.filter(trip => trip.status === "active")
    .reduce((sum, trip) => sum + tripRemainingFunds(trip), 0)
  + Number(carryForward || 0)
) * 100) / 100;

module.exports = { tripRemainingFunds, availableToSpend };
